export const step1Messages = {
  INVALID_SERIE_MESSAGE: 'El número que ingresaste no es válido',
  REQUIRED_SERIE_MESSAGE: 'Ingresa el número de serie o documento',
  INVALID_RUT_MESSAGE: 'Ingresa un RUT válido',
  REQUIRED_RUT_MESSAGE: 'Ingresa RUT',
  REQUIRED_EMAIL_MESSAGE: 'Ingresa el correo electrónico valido',
  REQUIRED_EMAILREPETIR_MESSAGE: 'El correo electrónico que ingresaste no coincide',
  INVALID_SERIE_OF_RUT: 'El número no corresponde a su rut',
  INVALID_PHONE_MESSAGE: 'El número de teléfono que ingresaste no es válido',
  REQUIRED_PHONE_MESSAGE: 'Ingresa tu número de teléfono',
  RUT_INFO_TOOLTIP: '<p>Utiliza tu <strong>RUT de Persona Natural</strong> para realizar la solicitud de tu producto.</p>En caso de contratar con tu <strong>RUT de empresa</strong>, selecciona el <strong>Perfil empresa</strong>.'
};
